import React, { Component } from 'react'
import { connect } from 'react-redux'

import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/MenuItem'
import Moment from 'moment'

import Checkbox from 'material-ui/Checkbox'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead, currentDate } from 'selectors/common'
import { propertiesLLEx } from 'selectors/properties'
import { lastPropertyLease } from 'selectors/leases'
import { getMonth, getTimezoneDate } from 'utils/date'

let select = dirtyRead(
  (state, props) => ({
    property: doc(state, props.propertyID)
    , events: propertiesLLEx(state)[props.propertyID]
      , lastPropertyLease: lastPropertyLease(state, props)
      , currentDate: currentDate(state)
  })
)

const statuses = {
  'For Rent': <img src="/landlord/static/img/property_statuses/pic-for-rent.png" alt="status" height="24px"/>,
  'Not In Service': <img src="/landlord/static/img/property_statuses/pic-not-occupied.png" alt="status" height="24px"/>,

  'Occupied': <img src="/landlord/static/img/property_statuses/pic-occupied.png" alt="status" height="24px"/>,

  'Unpaid': <img src="/landlord/static/img/property_statuses/picunpaid.png" alt="status" height="24px"/>,
  'Paid': <img src="/landlord/static/img/property_statuses/picpaid.png" alt="status" height="24px"/>,

  'Contracted': <img src="/landlord/static/img/property_statuses/pic-contracted.png" alt="status" height="24px"/>,

  'Retired': <img src="/landlord/static/img/property_statuses/pic-retired.png" alt="retired" height="24px"/>,
  'Under Maintenance': <img src="/landlord/static/img/property_statuses/pic-repair.png" alt="status" height="24px"/>,
}

export class StatusSelect extends Component{
  render(){
    let { props } = this
    return(
      <div style={{textAlign:'left'}}> 
        {props.events && props.events.status && props.events.status.forRent!='For Rent' && props.events.status.occupied!='Occupied' && !props.property.dateTill && Moment(props.lastPropertyLease.dateTill)<=Moment(props.currentDate) && <div
          style={{
            background: "none"
              , borderRadius: "50%"
              , paddingTop: "2px", marginLeft: "1px"
            , height: "30px"
            , width: "30px"
            , textAlign: "center"
            , display: "inline-block"
            , verticalAlign: "super"
            , float: "left"
          }}
        >
          {statuses['Not In Service']}
        </div>}
        {props.events && props.events.status && props.events.status.forRent=='For Rent' && !props.property.dateTill && <div
          style={{
            background: "none"
              , borderRadius: "50%"
              , paddingTop: "2px", marginLeft: "1px"
            , height: "30px"
            , width: "30px"
            , textAlign: "center"
            , display: "inline-block"
            , verticalAlign: "super"
            , float: "left"
          }}
        >
          {statuses['For Rent']}
        </div>}
        {props.events && props.events.status && props.events.status.contracted=='Contracted' && !props.property.dateTill  && <div
          style={{
            background: "none"
              , borderRadius: "50%"
            , marginLeft: "1px"
            , paddingTop: "2px"
            , height: "30px"
            , width: "30px"
            , textAlign: "center"
            , display: "inline-block"
            , verticalAlign: "super"
            , float: "left"
          }}
        >
            {statuses['Contracted']}
        </div>}
        {props.events && props.events.status && props.events.status.occupied=='Occupied' && !props.property.dateTill  &&  props.events.status.notPaying=='Not Paying' && <div
          style={{
            background: "none"
              , borderRadius: "50%"
            , marginLeft: "1px"
            , paddingTop: "4px"
            , height: "30px"
            , width: "30px"
            , textAlign: "center"
            , display: "inline-block"
            , verticalAlign: "super"
            , float: "left"
          }}
        >
          {statuses['Unpaid']}
        </div>}
        {props.events && props.events.status && props.events.status.occupied=='Occupied' && !props.property.dateTill  &&  props.events.status.notPaying!='Not Paying' && <div
          style={{
            background: "none"
              , borderRadius: "50%"
            , marginLeft: "1px"
            , paddingTop: "4px"
            , height: "30px"
            , width: "30px"
            , textAlign: "center"
            , display: "inline-block"
            , verticalAlign: "super"
            , float: "left"
            , verticalAlign: "super"
          }}
        >
          {statuses['Paid']}
        </div>}
        {props.property && props.property.dateTill && <div
          onRequestDelete={() =>{props.STAGE({_id: props.propertyID, dateTill: undefined})}}
          key={props.property.dateTill}
          backgroundColor="red"
          style={{
            background: "none"
              , borderRadius: "50%"
            , marginLeft:"10px"
            , paddingTop: "2px"
            , height: "30px"
            , width: "30px"
            , textAlign: "center"
            , color: "white"
          }}
        >
          {statuses['Retired']} {/*(getTimezoneDate(props.property.dateTill).getDate()>9?getTimezoneDate(props.property.dateTill).getDate():('0'+getTimezoneDate(props.property.dateTill).getDate()))+' '+getMonth(getTimezoneDate(props.property.dateTill).getMonth())+' '+getTimezoneDate(props.property.dateTill).getFullYear()%100*/}
        </div>}
      </div>
    )
  }
}

export default connect(select, dataActions)(StatusSelect)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/propertyForm/StatusSelect.js